document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.shopify-section--media-with-text');
  if (!section) {
    console.error('Error: .media-with-text section not found');
    return;
  }
  const firstBlock = section.querySelector('.media-with-text__item:first-child');
  const secondBlock = section.querySelector('.media-with-text__item:nth-child(2)');
  if (!firstBlock || !secondBlock) {
    console.error('Error: One or both blocks not found', { firstBlock, secondBlock });
    return;
  }
  const handleScroll = () => {
    const firstBlockRect = firstBlock.getBoundingClientRect();
    const secondBlockRect = secondBlock.getBoundingClientRect();
    const overlapThreshold = 50; 
    if (secondBlockRect.top <= firstBlockRect.bottom + overlapThreshold && secondBlockRect.bottom >= firstBlockRect.top) {
      firstBlock.classList.add('is-overlapped');
      secondBlock.classList.add('is-overlapping');
      console.log('Classes added: is-overlapped, is-overlapping');
    } else {
      firstBlock.classList.remove('is-overlapped');
      secondBlock.classList.remove('is-overlapping');
      console.log('Classes removed: is-overlapped, is-overlapping');
    }
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      console.log('Intersection Observer triggered', { isIntersecting: entry.isIntersecting });
      if (entry.isIntersecting) {
        window.addEventListener('scroll', handleScroll);
        handleScroll(); 
      } else {
        window.removeEventListener('scroll', handleScroll);
        firstBlock.classList.remove('is-overlapped');
        secondBlock.classList.remove('is-overlapping');
        console.log('Section out of view, classes reset');
      }
    });
  }, {
    root: null,
    threshold: 0.2, 
    rootMargin: '100px'
  });
  observer.observe(section);
});